import { render, staticRenderFns } from "./CommunityPostForm.vue?vue&type=template&id=0acfeecc&"
import script from "./CommunityPostForm.vue?vue&type=script&lang=js&"
export * from "./CommunityPostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports